module.exports = __webpack_public_path__ + "static/media/use-credit-icon.d17969fe.svg";